import { MEDIA_BASE } from '../routes'

export type HeroVideoSource = { src: string; type: string; media?: string }
export interface HeroVideo { readonly sources: readonly HeroVideoSource[]; readonly loop: boolean }

/**
 * Screens whose hero is ~2000 device px wide or more: big monitors, and HiDPI
 * laptops/tablets from 1024 CSS px. They get the 2560-px rendition; the 1080
 * would be upscaled there. (`-webkit-min-device-pixel-ratio` for Safari < 16.)
 */
export const HERO_1440_MEDIA =
  '(min-width: 1921px), (min-width: 1024px) and (min-resolution: 2dppx), (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2)'

/**
 * One looping clip (the old site's forest shot, re-encoded with
 * `transcode-hero.sh --quality high`: the foliage smeared at the default
 * rates); `null` would mean a photo-only hero. First matching source wins.
 */
export const HERO_VIDEO: HeroVideo | null = {
  sources: [
    { src: `${MEDIA_BASE}/hero/hero-forest-1440.mp4`, type: 'video/mp4', media: HERO_1440_MEDIA },
    { src: `${MEDIA_BASE}/hero/hero-forest-1080.mp4`, type: 'video/mp4', media: '(min-width: 768px)' },
    { src: `${MEDIA_BASE}/hero/hero-forest-720.mp4`, type: 'video/mp4' },
  ],
  loop: true,
}

export function heroVideoFiles(v: HeroVideo): string[] { return v.sources.map((s) => s.src) }

export function pickSource(v: HeroVideo, matches: (media: string) => boolean): HeroVideoSource {
  return v.sources.find((s) => !s.media || matches(s.media)) ?? v.sources[v.sources.length - 1]
}
